import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Link,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const TermsView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Terms of Service">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography color="textPrimary" variant="h2" gutterBottom>
            Terms of Service
          </Typography>
          <Typography color="textSecondary" variant="body1" gutterBottom>
            This page is under construction. Please check back soon.
          </Typography>
          <Box mt={2}>
            <Link component={RouterLink} to="/app/login" variant="body1">
              Back to Login
            </Link>
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default TermsView;
